import axios from '@/libs/api.request'

export const JobList = (data) => {
  return axios.request({
    url: '/print/job/list',
    params: data,
    method: 'get'
  })
}
export const DeleteJob = (data) => {
  return axios.request({
    url: '/print/job/del',
    data,
    method: 'post'
  })
}
export const JobTotalMoney = (data) => {
  return axios.request({
    url: '/print/job/total_money',
    params: data,
    method: 'get'
  })
}
export const WXReturnMoney = (data) => {
  return axios.request({
    url: '/print/machine/wx/return.money',
    data,
    method: 'post'
  })
}
export const ALIReturnMoney = (data) => {
  return axios.request({
    url: '/print/machine/ali/return.money',
    data,
    method: 'post'
  })
}
export const JobReturnMoney = (data) => {
  return axios.request({
    url: '/print/job/return_money',
    data,
    method: 'put'
  })
}

export const GetCapitalStatistic = (params) => {
  return axios.request({
    url: '/print/job/GetCapitalStatistic',
    params,
    method: 'get'
  })
}

export const JobOver = (data) => {
  return axios.request({
    url: '/print/job/JobOver',
    data,
    method: 'post'
  })
}

export const RefundJob = (data) => {
  return axios.request({
    url: '/print/machine/ali/return.tl',
    data,
    method: 'post'
  })
}
// 云知印后台查不到的订单退款
export const RefundErrorJob = (params) => {
  return axios.request({
    url: '/print/payment/orders/OrderRefund',
    params,
    method: 'get'
  })
}
